var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isloading)?_c('div',{staticClass:"button",on:{"click":_vm.clkbutton}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_c('div',{staticClass:"newbutton"},[_c('van-loading',{attrs:{"color":"#fff"}}),_vm._v(_vm._s(_vm.istitle)+"... ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }